import script from "./AccusedInCourt.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccusedInCourt.vue?vue&type=script&setup=true&lang=ts"

import "./AccusedInCourt.vue?vue&type=style&index=0&id=a6a0fac8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6a0fac8"]])

export default __exports__